@if (vm$ | async; as vm) {
  <div class="start-page">
    <section class="org-header">
      @if (vm.orgLogoPath) {
        <img class="org-header-logo" [src]="vm.orgLogoPath" [alt]="vm.orgName + ' logo'" />
      } @else {
        <mat-icon class="org-header-fallback">apartment</mat-icon>
      }
      <div class="org-header-copy">
        <h2>{{ vm.orgName }}</h2>
      </div>
    </section>

    <section class="welcome-panel">
      <div>
        <p class="eyebrow">{{'HOME.START_PAGE' | translate}}</p>
        <h1>{{ 'HOME.WELCOME' | translate: {name: vm.userName} }}</h1>
        <p class="subtext">{{'HOME.OVERVIEW' | translate}}</p>
        <p class="date-line">{{ welcomeDate | date: 'EEEE, yyyy-MM-dd' : undefined : vm.dateLocale }}</p>
      </div>
      <div class="quick-tiles">
        <a class="quick-tile" routerLink="/games3">
          <mat-icon>sports_hockey</mat-icon>
          <span>{{'HOME.OPEN_COMINGGAMES' | translate}}</span>
        </a>
        <a class="quick-tile" routerLink="/games3" [queryParams]="{ showPast: true }">
          <mat-icon>history</mat-icon>
          <span>{{'HOME.OPEN_PASTGAMES' | translate}}</span>
        </a>
      </div>
    </section>

    <section class="tile-grid">
<!--       <mat-card class="overview-tile reports-tile" appearance="outlined">
        <mat-card-content>
          <div class="tile-head">
            <mat-icon>rate_review</mat-icon>
            <span>{{'HOME.REPORTS' | translate}}</span>
          </div>
          <div class="tile-value">{{ vm.scoutingStats?.TotalReports ?? 0 }}</div>
          <p class="tile-caption">{{ vm.scoutingStats?.TimeValue ?? 1 }} {{ vm.scoutingStats?.TimeUnit ?? 'months' }}</p>
          <a mat-raised-button routerLink="/scouting">{{'HOME.GO_TO_REPORTS' | translate}}</a>
        </mat-card-content>
      </mat-card> -->

      <mat-card class="list-card scout-info-card" appearance="outlined">
        <mat-card-content>
          <div class="tile-head">
            <mat-icon>insights</mat-icon>
            <span>{{'HOME.SCOUT_INFO' | translate}}</span>
          </div>
          @if (vm.isLoadingScoutInfo) {
            <p class="muted">{{"HOME.LOADING_SCOUT_INFO" | translate}}</p>
          } @else {
            <div class="scout-info-grid">
              <div class="scout-info-column">
                <h4>{{'HOME.THIS_SEASON' | translate}}</h4>
                <div class="scout-stat-row">
                  <span>{{'HOME.NO_OF_REPORTS' | translate}}</span>
                  <strong>{{ statDisplay(vm.seasonScoutInfo.reports) }}</strong>
                </div>
                <div class="scout-stat-row">
                  <span>{{'HOME.NO_OF_NOTES' | translate}}</span>
                  <strong>{{ statDisplay(vm.seasonScoutInfo.notes) }}</strong>
                </div>
                <div class="scout-stat-row">
                  <span>{{'HOME.NO_OF_GRADED_GAMES' | translate}}</span>
                  <strong>{{ statDisplay(vm.seasonScoutInfo.gradedGames) }}</strong>
                </div>
                <div class="scout-stat-row">
                  <span>{{'HOME.NO_OF_SCHEDULEITEMS' | translate}}</span>
                  <strong>{{ statDisplay(vm.seasonScoutInfo.scheduleActivities) }}</strong>
                </div>
              </div>

              <div class="scout-info-column">
                <h4>{{'HOME.ALL_TIME' | translate}}</h4>
                <div class="scout-stat-row">
                  <span>{{'HOME.NO_OF_REPORTS' | translate}}</span>
                  <strong>{{ statDisplay(vm.lifetimeScoutInfo.reports) }}</strong>
                </div>
                <div class="scout-stat-row">
                  <span>{{'HOME.NO_OF_NOTES' | translate}}</span>
                  <strong>{{ statDisplay(vm.lifetimeScoutInfo.notes) }}</strong>
                </div>
                <div class="scout-stat-row">
                  <span>{{'HOME.NO_OF_GRADED_GAMES' | translate}}</span>
                  <strong>{{ statDisplay(vm.lifetimeScoutInfo.gradedGames) }}</strong>
                </div>
                <div class="scout-stat-row">
                  <span>{{'HOME.NO_OF_SCHEDULEITEMS' | translate}}</span>
                  <strong>{{ statDisplay(vm.lifetimeScoutInfo.scheduleActivities) }}</strong>
                </div>
              </div>
            </div>
            <!-- <p class="tile-caption">Reports and notes are loaded from scout activity stats. Graded games and schedule activity totals will appear when those values are available from the API.</p> -->
          }
        </mat-card-content>
      </mat-card>

<!--     <mat-card class="overview-tile activities-tile" appearance="outlined">
      <mat-card-content>
        <div class="tile-head">
          <mat-icon>speaker_notes</mat-icon>
          <span>{{'HOME.NOTES' | translate}}</span>
        </div>
        <div class="tile-value">{{ scoutingStats?.TotalNotes ?? 0 }}</div>
        <p class="tile-caption">{{'HOME.PERIOD_NOTES_COUNT' | translate}}</p>
        <a mat-button routerLink="/search/report">{{'HOME.FIND_NOTES' | translate}}</a>
      </mat-card-content>
    </mat-card> -->

<!--     <mat-card class="overview-tile message-tile" appearance="outlined">
      <mat-card-content>
        <div class="tile-head">
          <mat-icon>person</mat-icon>
          <span>My Items</span>
        </div>
        <div class="tile-value">{{ scoutingStats?.MyItems ?? 0 }}</div>
        <p class="tile-caption">My reports + notes in selected period</p>
        <a mat-button routerLink="/search/report">Find reports</a>
      </mat-card-content>
    </mat-card> -->

    
      <mat-card class="list-card" appearance="outlined">
        <mat-card-content>
          <h3>
            <mat-icon>event</mat-icon>
            {{'HOME.COMING_ACTIVITIES' | translate}}
          </h3>
          @if (vm.isLoadingActivities) {
            <p class="muted">{{'HOME.LOADING_ACTIVITIES' | translate}}</p>
          } @else if (vm.comingActivities.length === 0) {
            <p class="muted">{{'HOME.NO_UPCOMING_ACTIVITIES' | translate}}</p>
          } @else {
            <div class="list-items">
              @for (activity of vm.comingActivities; track activity.EventId) {
                @if(activity.EventType=='GAME') {
                    <button type="button" class="list-row list-row-button" (click)="openComingActivity(activity)">
                      <div class="ghf-matchup">
                        <div class="ghf-team">
                          <img class="ghf-logo"
                            [src]="activity.HomeTeamIconFileName ? getIconPath(activity.HomeTeamIconFileName) : '/assets/img/placeholder.png'"
                            (error)="handleImageError($event)" alt="Home">
                          <span class="ghf-team-name">{{ activity.HomeTeamName }}</span>
                        </div>
                        <div class="ghf-center">
                          <div class="ghf-date">
                            {{ activity.EventStart | date: 'dd' }}
                            {{ activity.EventStart | date: 'LLL' }}
                          </div>
                          <div class="ghf-time">{{ activity.EventStart | date: 'HH:mm' }}</div>
                        </div>
                        <!-- Away team -->
                        <div class="ghf-team">
                          <img class="ghf-logo"
                            [src]="activity.AwayTeamIconFileName ? getIconPath(activity.AwayTeamIconFileName) : '/assets/img/placeholder.png'"
                            (error)="handleImageError($event)" alt="Away">
                          <span class="ghf-team-name">{{ activity.AwayTeamName }}</span>
                        </div>
                      
                        <!-- <div class="ghf-venue">{{ activity.Game.Venue }}</div> -->
                      </div>
                    </button>
                   <!--  <button type="button" class="list-row list-row-button" (click)="openComingActivity(activity)">
                      <div class="list-sub">{{ activity.EventStart | date: 'yyyy-MM-dd HH:mm' }} · {{ activity.HomeTeamName }} {{
                        activity.AwayTeamName ? '- ' + activity.AwayTeamName : '' }}</div>
                    </button> -->
                    } @else {
                    <button type="button" class="list-row list-row-button" (click)="openComingActivity(activity)">
                      <div class="list-main">{{ activity.Title || activity.EventType || ('HOME.ACTIVITY' | translate) }}</div>
                      <div class="list-sub">{{ activity.EventStart | date: 'yyyy-MM-dd HH:mm' }} · {{ activity.HomeTeamName }} {{
                        activity.AwayTeamName ? '- ' + activity.AwayTeamName : '' }}</div>
                    </button>
                }
               
              }
            </div>
          }
        </mat-card-content>
      </mat-card>
    </section>
  
<!-- 
  <section class="stats-grid">
    <mat-card class="list-card" appearance="outlined">
      <mat-card-content>
        <h3>Scouting Activity Stats</h3>
        @if (isLoadingStats) {
          <p class="muted">Loading scouting activity stats...</p>
        } @else {
          <div class="stats-rows">
            <div class="stats-row">
              <span>Period</span>
              <strong>{{ scoutingStats?.FromDate | date: 'yyyy-MM-dd' }} - {{ scoutingStats?.ToDate | date: 'yyyy-MM-dd' }}</strong>
            </div>
            <div class="stats-row">
              <span>Time unit</span>
              <strong>{{ scoutingStats?.TimeValue ?? 0 }} {{ scoutingStats?.TimeUnit ?? '-' }}</strong>
            </div>
            <div class="stats-row">
              <span>Total reports</span>
              <strong>{{ scoutingStats?.TotalReports ?? 0 }}</strong>
            </div>
            <div class="stats-row">
              <span>Total notes</span>
              <strong>{{ scoutingStats?.TotalNotes ?? 0 }}</strong>
            </div>
            <div class="stats-row">
              <span>Total items</span>
              <strong>{{ scoutingStats?.TotalItems ?? 0 }}</strong>
            </div>
            <div class="stats-row">
              <span>My reports</span>
              <strong>{{ scoutingStats?.MyReports ?? 0 }}</strong>
            </div>
            <div class="stats-row">
              <span>My notes</span>
              <strong>{{ scoutingStats?.MyNotes ?? 0 }}</strong>
            </div>
            <div class="stats-row">
              <span>My items</span>
              <strong>{{ scoutingStats?.MyItems ?? 0 }}</strong>
            </div>
          </div>
        }
      </mat-card-content>
    </mat-card>
  </section> -->

    <section class="overview-lists">
      <mat-card class="list-card" appearance="outlined">
        <mat-card-content>
          <h3>
            <mat-icon class="material-icons-outlined">rate_review</mat-icon>
            {{'HOME.LATEST_REPORTS' | translate}}
          </h3>
          @if (vm.isLoadingReports) {
            <p class="muted">{{'HOME.LOADING_REPORTS' | translate}}</p>
          } @else if (vm.recentReports.length === 0) {
            <p class="muted">{{'HOME.NO_REPORTS_FOUND' | translate}}</p>
          } @else {
            <div class="list-items">
              @for (report of vm.recentReports; track report.ReportId) {
                <button type="button" class="list-row list-row-button" [class]="reportBorderClass(report)" (click)="openReportDetails(report)">
                  <div class="list-main">{{ report.PlayerLastName }}, {{ report.PlayerFirstName }}</div>
                  <div>{{ report.TotalQualityText }}</div>
                  @if (report.GameText ) {
                    <div class="list-sub">
                      @if (report.GameDate) {
                        {{ report.GameDate | date: 'yyyy-MM-dd' }}
                      }
                      @if (report.GameText) {
                        {{ report.GameDate ? ' · ' : '' }}{{ report.GameText }}
                      }
                    </div>
                  }
                  <div class="list-sub">{{report.CreatedByLastName}}, {{report.CreatedByFirstName}} · {{ report.DateCreated | date: 'yyyy-MM-dd' }} </div>
                </button>
              }
            </div>
          }
        </mat-card-content>
      </mat-card>

    </section>
  </div>
}
